import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425ead45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown-divider"
}

import { useRouter } from 'vue-router'
import { ref, computed, onMounted } from 'vue'

import { useAppStore } from '@/popup/store/AppStore'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Dropdown from '@/popup/components/shared/Dropdown/Dropdown.vue'
import DropdownItem from '@/popup/components/shared/Dropdown/DropdownItem.vue'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'
import NetworkChangeConfirmation from '@/popup/components/Modal/NetworkChangeConfirmation.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'

type Props = {
  from: 'settings' | 'add-account'
}

type Emits = {
  (event: 'onNetworkSwitch', networkId: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Network',
  props: {
    from: {}
  },
  emits: ["onNetworkSwitch"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const router = useRouter()
const appStore = useAppStore()
const dropdownOpened = ref(false)
const selectedNetwork = computed(() => appStore.network)
const isConfirmationDisplayed = ref(false)

const allNetworks = ref<NetworkInfoDBSchema[]>([])

onMounted(async () => {
  allNetworks.value = await useGlobals().sendMessage({
    method: InternalMethods.GET_NETWORKS,
    payload: undefined,
  })
})

const onNetworkChange = async (network: NetworkInfoDBSchema) => {
  if (network.id === selectedNetwork.value.id) {
    return
  }
  const previousNetwork = selectedNetwork.value
  try {
    const selectedProfile = await appStore.switchToNetwork(network.id)
    if (selectedProfile) {
      router.push('/')
    } else {
      router.push({
        path: appStore.network.id.startsWith('base')
          ? '/add-base-account'
          : '/add-account',
        query: {
          from: props.from,
        },
      })
    }
    emits('onNetworkSwitch', network.id)
  } catch {
    await appStore.switchToPreviousNetwork()
    emits('onNetworkSwitch', previousNetwork.id)
  } finally {
    dropdownOpened.value = false
    if (props.from === 'settings') {
      isConfirmationDisplayed.value = true
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalTransition, null, {
      default: _withCtx(() => [
        (
        !_unref(appStore).state.hasDisplayedNetworkSwitchInfo && isConfirmationDisplayed.value
      )
          ? (_openBlock(), _createBlock(NetworkChangeConfirmation, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(Dropdown, {
      selected: selectedNetwork.value.name
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allNetworks.value, (network) => {
          return (_openBlock(), _createBlock(DropdownItem, {
            key: network.id,
            "is-active": selectedNetwork.value.id === network.id,
            "data-testid": network.id,
            onClick: ($event: any) => (onNetworkChange(network))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(network.name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_2, [
                (network.isCustom && _ctx.from === 'settings')
                  ? (_openBlock(), _createBlock(SvgIcon, {
                      key: 0,
                      name: "edit",
                      class: "edit",
                      color: "var(--neutral-20)",
                      onClick: _withModifiers(($event: any) => (
            _unref(router).push({
              name: 'network',
              params: { networkId: network.id },
            })
          ), ["stop"]),
                      "data-testid": `edit-` + network.id
                    }, null, 8 /* PROPS */, ["onClick", "data-testid"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-active", "data-testid", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.from === 'settings')
          ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
          : _createCommentVNode("v-if", true),
        (_ctx.from === 'settings')
          ? (_openBlock(), _createBlock(DropdownItem, {
              key: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _unref(router).push({
          name: 'network',
        })
      )),
              "data-testid": "add",
              class: "add"
            }, {
              default: _withCtx(() => [
                _createVNode(SvgIcon, {
                  name: "plus",
                  color: "var(--neutral-20)",
                  class: "mr-3"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.network.add_network_tooltip')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["selected"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})